import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Constant, { getCountryTimeZone } from '../../Constant.js'
import axios from 'axios'
import Swal from 'sweetalert2'
import moment from 'moment'
const momentTz = require('moment-timezone')
class ViewBoatDetails extends Component {
  state = {
    Availabletimeslots: {},
    arrayBlockedslots: [],
    arrayBookedslots: [],
    arrayTimeslots: [],
    newClass: [],
    timeSlots: [
      '00',
      '01',
      '02',
      '03',
      '04',
      '05',
      '06',
      '07',
      '08',
      '09',
      '10',
      '11',
      '12',
      '13',
      '14',
      '15',
      '16',
      '17',
      '18',
      '19',
      '20',
      '21',
      '22',
      '23',
    ],
    isLoading: false,
    isSaving: false,
  }
  myStyle = {
    fontWeight: 'bold',
  }
  StyleForDetail = {
    marginBottom: '6px',
    letterSpacing: '0.5px',
    display: 'inline-block',
  }

  componentDidMount() {
    this.getAvailabletimeslots()
  }

  onSaving = () => {
    this.setState({ isSaving: true })

    var dateDMY = moment(this.state.Availabletimeslots?.cruise_booking_date).format('MM/DD/YYYY')

    var data = {
      cruise_id: this.props.match?.params?.boatId,
      data: [
        {
          cruise_booking_date: dateDMY,
          time_slots: this.state?.arrayTimeslots?.sort(),
          block_slots: this.state.arrayBlockedslots?.sort(),
        },
      ],
    }

    axios
      .put(Constant.getAPI() + '/slots/update-calendar-time-slot', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(() => {
        Swal.fire({
          title: 'Slots updated Successfully!',
          icon: 'success',
          text: '',
          type: 'success',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        })
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isSaving: false,
        })
      })
  }

  handleChange = (slot) => {
    if (this.state.arrayBlockedslots.includes(slot)) {
      this.setState({
        arrayBlockedslots: this.state.arrayBlockedslots.filter((item) => item != slot),
        arrayTimeslots: [...new Set([...this.state.arrayTimeslots, slot])],
      })
    } else {
      this.setState({
        arrayTimeslots: this.state.arrayTimeslots.filter((item) => item != slot),
        arrayBlockedslots: [...new Set(this.state.arrayBlockedslots), slot],
      })
    }
  }

  getAvailabletimeslots = async () => {
    this.setState({ isLoading: true })

    var data = {
      cruise_id: this.props?.match?.params?.boatId,
    }

    await axios
      .post(Constant.getAPI() + `/slots/get-calendar-time-slots`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        var selectedDate = res?.data?.data?.find((itm) => itm.id === this.props?.match?.params?.timeId)

        selectedDate.time_slots.sort((a, b) => a.localeCompare(b))

        this.setState(
          {
            Availabletimeslots: selectedDate,
          },
          () => {
            this.setState({
              arrayBlockedslots: this.state.Availabletimeslots.block_slots,
              arrayBookedslots: this.state.Availabletimeslots.booked_slots,
              arrayTimeslots: this.state.Availabletimeslots.time_slots,
            })
          }
        )
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  checkSlotAvailable = (date, time) => {
    let slot = moment(`${date} ${time}:00:00`).format('YYYY-MM-DD HH:mm:ss')
    let currentTime = momentTz()
      .tz(getCountryTimeZone(localStorage.getItem('countryShortName')))
      .format('YYYY-MM-DD HH:mm:ss')
    return moment(currentTime).isAfter(moment(slot))
  }

  render() {
    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>{this.props.match?.params?.boatType} Timeslots</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to={`/boatsmaster/${this.props.match?.params?.boatType}`}>
                          {this.props.match?.params?.boatType} Lists{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">{this.props.match?.params?.boatType} Details</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div>
                        <b>Date:-</b> {this.state.Availabletimeslots?.cruise_booking_date}
                      </div>
                      <div
                        className="timeslotts"
                        style={{ margin: '5px' }}
                      >
                        {this.state.timeSlots.map((item) => (
                          <button
                            style={{ margin: 5, width: 100 }}
                            className={`btn ${
                              this.state.arrayBookedslots.includes(item)
                                ? 'bookedSlot'
                                : this.state.arrayBlockedslots.includes(item)
                                  ? 'BlockedSlot'
                                  : !this.state.arrayTimeslots.includes(item)
                                    ? 'Inactive'
                                    : 'Timeslots'
                            }`}
                            disabled={
                              this.checkSlotAvailable(this.state.Availabletimeslots?.cruise_booking_date, item) ||
                              this.state.arrayBookedslots.includes(item) ||
                              (!this.state.arrayTimeslots.includes(item) &&
                                !this.state.arrayBlockedslots.includes(item))
                                ? true
                                : false
                            }
                            onClick={() => this.handleChange(item)}
                          >
                            {item}:00
                          </button>
                        ))}
                      </div>
                      {this.state.isLoading && 'Loading...'}
                    </div>
                    <div className="card-footer">
                      <div className="row">
                        <div className="col-1 text-center">
                          <div
                            className="bookedSlot"
                            style={{ height: 10, borderRadius: '10px' }}
                          ></div>{' '}
                          Booked Slots
                        </div>
                        <div className="col-1 text-center">
                          <div
                            className="Timeslots"
                            style={{ height: 10, borderRadius: '10px' }}
                          ></div>{' '}
                          Available Slots
                        </div>
                        <div className="col-1 text-center">
                          <div
                            className="BlockedSlot"
                            style={{ height: 10, borderRadius: '10px' }}
                          ></div>{' '}
                          Blocked Slots
                        </div>
                        <div className="col-1 text-center">
                          <div
                            className="Inactive"
                            style={{ height: 10, borderRadius: '10px' }}
                          ></div>{' '}
                          Inactive Slots
                        </div>
                        <div className="text-right col-6 offset-2">
                          {this.state.isSaving ? (
                            <button
                              className="btn btn-grd-disabled mr-2"
                              disabled
                            >
                              Saving...!
                            </button>
                          ) : (
                            <button
                              onClick={() => this.onSaving()}
                              className="btn hor-grd btn-grd-inverse offset-1"
                            >
                              <i className="ti-save"></i>Save
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ViewBoatDetails
